module.exports = __webpack_public_path__ + "media/recipes/15-9dd1428c.png";